module.exports = __webpack_public_path__ + "img/ic_white_spanish.b96c41c7.svg";